var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avue-crud',{attrs:{"option":_vm.tableConfig,"data":_vm.basicInfoData.planList,"page":_vm.page,"summary-method":_vm.summaryMethod},on:{"update:page":function($event){_vm.page=$event}},scopedSlots:_vm._u([{key:"isWriteoff",fn:function({ row }){return [_c('div',[_vm._v("\n      "+_vm._s(row.isWriteoff == 2
          ? "提前结清"
          : row.isWriteoff == 1
          ? "已结清"
          : row.isWriteoff == 0
          ? _vm.basicInfoData.prepayment.isWriteoff == 1
            ? "提前还款"
            : "待结清"
          : "")+"\n    ")])]}}]),model:{value:(_vm.tableForm),callback:function ($$v) {_vm.tableForm=$$v},expression:"tableForm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }